<template>
    <div class="overflow-y-scroll lg:overflow-auto">
        <div v-if="customFields?.cool_storage" class="mb-12">
            <div class="text-xl text-link font-semibold pb-4">
                {{ t('product.tabsNutrition.storage') }}
            </div>
            <div class="text-lg">
                {{ t('product.tabsNutrition.storageInfo') }}
            </div>
        </div>

        <div v-if="manufacturer?.description" class="mb-12">
            <div class="text-xl text-link font-semibold pb-4">
                {{ t('product.tabsNutrition.manufacturer') }}
            </div>

            <div class="text-lg" v-html="manufacturer?.description" />
        </div>

        <div>
            <div v-if="customFields?.caloric_value_kj > 0" :class="customFields?.additional_nutrition_values ? 'mb-12' : 'mb-4'">
                <div class="text-xl mb-2 font-semibold text-headline">
                    {{ t('product.tabsNutrition.nutrition') }}
                </div>

                <div v-if="customFields?.reference_quantity" class="text-lg mb-3">
                    {{ t('product.tabsNutrition.dataPer') }} {{ customFields?.reference_quantity }}
                </div>

                <div v-if="customFields?.caloric_value_kj > 0">
                    <ProductDetailNutritionTable :custom-fields="customFields" />
                </div>
            </div>

            <div v-if="customFields?.additional_nutrition_values" class="mb-4">
                <ProductDetailAdditionalNutritionTable
                    :custom-fields="customFields"
                />
            </div>

            <div v-if="customFields?.nutritional_recommendation">
                <div class="text-lg">
                    {{ customFields?.nutritional_recommendation }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    customFields?: object | undefined
    manufacturer?: object | undefined | null
}>()
</script>
